export var DropdownPosition;
(function (DropdownPosition) {
    DropdownPosition["TOP"] = "top";
    DropdownPosition["BOTTOM"] = "bottom";
})(DropdownPosition || (DropdownPosition = {}));
